<template>
  <div class="visual-element-quote">
    <FormVisualElement class="col-1/2" @valid="$emit('valid', $event)">
      <FormRow
        label="Citazione"
        legend="(massimo 210 caratteri)"
        :for-id="`visual-element-quote-text-${_id}`"
        name="Citazione"
        rules="required"
      >
        <v-medium-editor
          :id="`visual-element-quote-text-${_id}`"
          name="quote"
          v-model="modelDataElement.text"
          row="10"
        />
      </FormRow>

      <FormRow
        label="Nome e cognome dell'autore"
        :for-id="`visual-element-quote-autor-${_id}`"
        name="Citazione"
        rules="required|html_max:210"
      >
        <v-input
          :id="`visual-element-quote-autor-${_id}`"
          type="text"
          name="author"
          v-model="modelDataElement.author"
        />
      </FormRow>
    </FormVisualElement>
  </div>
</template>

<script>
/** Components */
import VisualElementBase from '@/components/VisualElementBase.vue'
// Charles Batchelor

export default {
  extends: VisualElementBase,

  defaultContent: {
    text: '',
    author: '',
  },
}
</script>
